var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import Button from '@telia-front/button';
import Search from '@telia-front/search';
import { useTheme } from '@telia-front/theme-provider';
const HeaderSearch = (props) => {
    const { detailedViewButton, onSubmit, id = 'header-search' } = props, rest = __rest(props, ["detailedViewButton", "onSubmit", "id"]);
    const { media } = useTheme();
    const isFullWidth = useMediaQuery({ maxWidth: media.width.xs.max });
    return (React.createElement(Search, Object.assign({}, rest, { onSubmit: onSubmit, className: "header__search", id: id, hideLabel: "no-break", placeholderLabel: true, fullWidth: isFullWidth, suggestionClassName: "header__search-suggestion", offsetY: 5, suggestionContent: React.createElement(Button, Object.assign({}, detailedViewButton, { link: true, className: "header__search-suggestion-button", iconRight: "#arrow-right" })), formAttributes: Object.assign(Object.assign({}, rest.formAttributes), { role: 'search' }) })));
};
export default HeaderSearch;
